import { useMutation, useQuery } from "@apollo/client";
import { CewpUserView } from "components/cards";
import { Modal } from "components/layouts";
import { FC } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { withRoles, wrapClick } from "utils";
import { DELETE_CEWP_USER, GET_CEWP_USER } from "./apollo";

interface DeleteCewpUserContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}

const DeleteCewpUserContainer: FC<DeleteCewpUserContainerProps> = ({
  open,
  setOpen,
  refetch,
}) => {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_CEWP_USER, {
    variables: {
      id: searchParams.id,
    },
    skip: !searchParams.id,
    notifyOnNetworkStatusChange: false,
  });

  const [deleteCEWPUser, { loading: loadingDelete }] = useMutation(
    DELETE_CEWP_USER,
  );

  const deleteItem = async () => {
    await deleteCEWPUser({
      variables: {
        id: searchParams.id,
      },
    }).then(({ data: result }) => {
      if (result?.deleteCEWPUser?._id) {
        toast(
          JSON.stringify({
            type: "success",
            title: "CEWP User Deleted Successfully",
          }),
        );
        refetch?.();
        setOpen(false);
      } else {
        toast(
          JSON.stringify({
            type: "error",
            title: "Could not delete CEWP user",
          }),
        );
      }
    });
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Delete CEWP User"
      description="Are you sure you want to delete this CEWP user? This action marks the user as deleted."
      renderActions={() => (
        <>
          {withRoles(["Super"])(
            <button
              type="button"
              disabled={loadingDelete}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(deleteItem)}
            >
              {loadingDelete ? "Deleting..." : "Delete User"}
            </button>,
          )}
        </>
      )}
    >
      {data?.user?._id && <CewpUserView user={data.user} />}
    </Modal>
  );
};

export default DeleteCewpUserContainer;
